export default __webpack_public_path__ + "static/media/LOGO_JonhnsonControls.0f30e6c4.png";